export default __webpack_public_path__ + "static/media/seiImage.94fed905.svg";